export default __webpack_public_path__ + "static/media/instagram_post_summary_1.23504c6a.png";